import React from "react";
import { FormControl, Select, MenuItem, Box, Typography } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

/**
 * FormSelect
 * @param {Array<{value: string|number, label: string}>} options - 選択肢
 * @param {any} value - 現在の値
 * @param {function} onChange - 値変更時の関数
 * @param {string} label - ラベル
 * @param {boolean} isRequired - 必須かどうか
 * @param {boolean} error - エラー表示
 * @param {string} placeholder - プレースホルダー
 */
const FormSelect = ({
  options = [],
  value,
  onChange,
  label = "",
  isRequired = false,
  error = false,
  placeholder = "選択してください",
}) => (
  <Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
      {label && <Typography sx={{ fontSize: 14 }}>{label}</Typography>}
      <RequiredLabel show={isRequired} />
    </Box>
    <FormControl sx={{ width: "100%" }} error={error}>
      <Select value={value ?? ""} onChange={(e) => onChange(e.target.value)}>
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
);

export default FormSelect;
